import { dayJsFormatDate } from '../../util/dateAdapter';
export const transformReimbursementHistoryData = (entry) => ({
    ...entry,
    id: entry.Id,
    EmployeeName: `${entry.FName} ${entry.LName}`,
    ReimbursedDate: dayJsFormatDate(new Date(entry.ReimbursedDate), 'MM/DD/YYYY')
});
export const isWordInEntry = (entry, word) => {
    return Object.values(entry).some((value) => value.toString().toLowerCase().includes(word.toLowerCase()));
};
